import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { jsPDF } from "jspdf";
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { CourseService } from "../../services/course.service";

@Component({
  selector: 'app-view-courses',
  templateUrl: './view-courses.component.html',
  styleUrls: ['./view-courses.component.scss'],
  providers: [DatePipe]
})
export class ViewCoursesComponent implements OnInit {

  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  userCourseList: any[]=[];
  userDetail: any;userLoginData: any = []; 
  userID:any;
  adminData: any;
  searchText: string="";
  order_by = "asc"; currentBaseUrl: any = '';
  order:any='course_name';
  assignCompleteCourses: any = [];
  course_id:any;assessment_id:any; request_status:number=0;reject_reason:string="";
  submitted = false;user_id:any;myDate = new Date();currentData: any = '';

  constructor(private modalService: NgbModal,private authCours: CourseService, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,private datePipe: DatePipe,
    private router: Router, private spinner: NgxSpinnerService) { 
      if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
        this.router.navigateByUrl('/admin-login');
      }
      this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    }

    rejectForm = new FormGroup({
      txtRemark: new FormControl('',[Validators.required] ),
    });
    get f() { return this.rejectForm.controls; } 
    open(content: any, course_id: any) {
      this.course_id = course_id;
      this.modalService.open(content, { centered: true, size: 'md' });
    }
  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const id = +params.user_id;
      if (id > 0) {
        this.userID = id;
      }
      this.assignCourseDetail(this.userID);
    this.getUserDetail(this.userID);
  
    this.getUserCourseList(this.userID, this.searchText,this.order,this.order_by);
  });
  this.currentBaseUrl = environment.BASEURL;
  //this.currentBaseUrl ='http://localhost:4200/';
  }
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order = sort.active; 
      this.order_by = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order = sort.active;
       this.order_by = 'ASC';
    } else { this.order = 'course_name'; 
    this.order_by = 'DESC'; }
    this.getUserCourseList(this.userID, this.searchText,this.order,this.order_by);
  };
  DeAssignUser(course_id: any) {
    this.authCours.DeAssignUsers(course_id, this.userID).subscribe(
      (data) => {
        if (data.status == 200) {
          this.getUserCourseList(this.userID, this.searchText,this.order,this.order_by);
         // this.viewUserProgress(this.course_id, this.searchText, this.order, this.order_by, this.filter_by_org);
          document.getElementById('closelId')?.click();
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }

  is_download_enable:Boolean = false;

  /*get user course list data********/
  getUserCourseList(user_id:any,searchText:any, order:any, order_by:any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserCourseList(user_id, searchText, order, order_by).subscribe(
      (data) => {
        if (data.success) {
          this.spinner.hide();
          this.userCourseList = data.user_course_list;
          
          this.userCourseList.forEach((element:any) => {
            if (element.percent_complete >= 100) {
              this.is_download_enable = true;
            }
          });/*dowload certification after 1 course doen code Milan */

          console.log('is_download_enable',this.is_download_enable);
          
           console.log(this.userCourseList,'gfgg');
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getUserDetail(userID:any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserDetail(userID).subscribe(
      (data) => {
        this.userDetail=data.userList;
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  openAccept(content: any, data:any) { 
    //console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=2
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  acceptRejectCourses(user_id:number,course_id:any,assessment_id:any, request_status:any, reject_reason:any){
    this.spinner.show();
    this.contentAuthoringApi.ViewCoursesAcceptReject(user_id,course_id,assessment_id, request_status, reject_reason).subscribe(
      data=>{
       //console.log(data)
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data:any) { 
  //  console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=3
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 
  }
  secondsToHms(d:any) {   
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h+ ' hr ' +m+ ' min' ; 
  }
  assignCourseDetail(ID:any) {
    this.contentAuthoringApi.assignCourses(3,ID).subscribe(
      data => {
        this.assignCompleteCourses = data.data;
        console.log(data.data,'data.data')
      }, error => {
      }
    )
  }
  alldownloadCartiCourse(){
    let arr: Array<any> = this.assignCompleteCourses;
    arr.forEach(element => {
      setTimeout(() => {
        this.downloadCartiCourse(element.course_name,element.user_course_progress.course_completed_dttm);
        }, 5000);
    });
  }
//   onSubmit(rejectForm: any) {
//     this.submitted = true;
//     if(this.rejectForm.invalid) { this.spinner.hide(); return; }
//     this.reject_reason= this.rejectForm.controls.txtRemark.value;
//     this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
//     this.rejectForm.reset();
//     this.modalService.dismissAll();
//     //document.getElementById('close')?.click();
//    // this.router.navigateByUrl('/view_courses',)
//     this.redirectTo('/view_courses');
//    }
//    redirectTo(uri:string){
//     this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
//     this.router.navigate([uri], { queryParams: {user_id: this.userID} }));
//  }
  toTitleCase(str:any) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word:any) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }
 /****download cartificate for completed course start  */
 downloadCartiCourse(course_name: any,course_completed_dttm:any) {
  const filteredCourses  = this.assignCompleteCourses.filter((course:any) => course.course_name === course_name);
  this.currentData = this.datePipe.transform(filteredCourses?.[0]?.user_course_progress?.course_completed_dttm, 'dd/MM/yyyy');
  //let fullNames = (this.userDetail.first_name + " " + this.userDetail.last_name).toLowerCase() ;
  const fullName = this.toTitleCase((this.userDetail.first_name + " " + this.userDetail.last_name).toLowerCase());
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: "px",
    format: [550, 297],
  });
  var width = doc.internal.pageSize.getWidth();

  doc.setDrawColor(35, 36, 115); // draw red lines
  // TOP
  doc.setLineWidth(10);
  doc.line(0, 0, 600, 0);
  // Bottom
  doc.setLineWidth(5);
  doc.line(0, 295, 600, 295);
  //LEFT
  doc.setLineWidth(10);
  doc.line(0, 600, 0, 0);
  //RIGHT 
  doc.setLineWidth(10);
  doc.line(550, 500, 550, 0);
  doc.addImage(this.currentBaseUrl + 'assets/images/logo.png', 'PNG', 460, 20, 70, 15);
  doc.addImage(this.currentBaseUrl + 'assets/images/vandhanalogo.jpeg', 'JPEG',  15, 5, 80, 50);
  doc.addFont(this.currentBaseUrl + 'assets/font/itcedscr-webfont.ttf', 'edwardian_script_itcregular', 'normal');
  doc.setFont('edwardian_script_itcregular');
  doc.setFontSize(50);
  doc.setTextColor(67, 67, 67);
  doc.text("Certificate of Course Completion", width / 2, 90, { align: 'center' });
  if(fullName.length < 50){
    doc.setFontSize(25);
    doc.setTextColor(67, 67, 67);
    doc.text("This is to Certify that " +`" `  + fullName + `"`+ " has successfully completed", width / 2, 123, { align: 'center' });
    if(course_name.length < 50){
      doc.setLineWidth(0.5);
      // doc.line(320, 132, 210, 132);
      doc.setFontSize(27);
      doc.setTextColor(67, 67, 67);
      // doc.text(course_name + " on " + this.currentData + "", width / 2, 155, { align: 'center' });
      doc.text( `" ` + course_name + `" `+ " on " + this.currentData + "", width / 2, 155, { align: 'center' });
      doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 205, 60, 18);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(50, 225, 140, 225);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 125);
      doc.text("Ashish Agarwal", 63, 235);
      doc.text("Sr. Training Manager", 57, 250);
      doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 185, 52, 70);
      //doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 420, 205, 65, 20);
      doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 205, 65, 20);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(498, 225, 415, 225);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 125);
      doc.text("Diwakar Dubey", 425, 235);
      doc.text("Training Manager", 420, 250) ;
    }else{
      doc.setLineWidth(0.5);
      // doc.line(320, 132, 210, 132);
      doc.setFontSize(27);
      doc.setTextColor(67, 67, 67);
      doc.text(`" ` + course_name + `" ` , width / 2, 155, { align: 'center' });
      doc.setFontSize(27);
      doc.setTextColor(67, 67, 67);
      doc.text( " on " + this.currentData , width / 2, 180, { align: 'center' });
      doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(50, 245, 140, 245);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 145);
      doc.text("Ashish Agarwal", 63, 255);
      doc.text("Sr. Training Manager", 57, 270);
      doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 205, 52, 70);
      doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(498, 245, 415, 245);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 145);
      doc.text("Diwakar Dubey", 425, 255);
      doc.text("Training Manager", 420, 270) ;
    }
}else{
  doc.setFontSize(25);
  doc.setTextColor(67, 67, 67);
  doc.text("This is to Certify thats " +`" `  + fullName + `"`, width / 2, 123, { align: 'center' });
  doc.setFontSize(25);
  doc.setTextColor(67, 67, 67);
  doc.text(" has successfully completed", width / 2, 146, { align: 'center' });
  if(course_name.length < 50){
    doc.setLineWidth(0.5);
    // doc.line(320, 132, 210, 132);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(`" ` + course_name + `" `+ " on " + this.currentData + "", width / 2, 175, { align: 'center' });
    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(50, 245, 140, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Ashish Agarwal", 63, 255);
    doc.text("Sr. Training Manager", 57, 270);
    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 205, 52, 70);
    doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(498, 245, 415, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Diwakar Dubey", 425, 255);
    doc.text("Training Manager", 420, 270);
  }else{    
    doc.setLineWidth(0.5);
    // doc.line(320, 132, 210, 132);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(`" ` + course_name + `" `, width / 2, 175, { align: 'center' });
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(" on " + this.currentData + "", width / 2, 195, { align: 'center' });
    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 240, 60, 18);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(50, 260, 140, 260);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 160);
    doc.text("Ashish Agarwal", 63, 270);
    doc.text("Sr. Training Manager", 57, 285);
    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 220, 52, 70);
    doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 240, 65, 20);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(498, 260, 415, 260);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 160);
    doc.text("Diwakar Dubey", 425, 270);
    doc.text("Training Manager", 420, 285);
  }

}

  // doc.addImage(this.currentBaseUrl + 'assets/images/vandhana.jpg', 'JPG', 448, 240, 80, 50);

  doc.save(course_name +"_certificate.pdf");
  //this.router.navigate(['/view_courses']);
  this.router.navigate(['/view_courses'], { queryParams: {user_id: this.userID} });

}

}
